import { Button } from 'components/admin/ui/Button';
import { Form } from 'components/admin/ui/Form';
import { ChangeEvent, FormEvent, useState } from 'react';
import { ImpersonationToolbar } from './ImpersonationToolbar';
import css from './StartImpersonationView.module.scss';
import { useImpersonationContext } from './context';

export const StartImpersonationView = () => {
  const { startImpersonation } = useImpersonationContext();

  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [userId, setUserId] = useState<number | undefined>(undefined);

  const handleInputChange = (event: ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value;
    const number = Number(value);
    setUserId(isNaN(number) ? undefined : number);
  };

  const handleStartImpersonation = async () => {
    if (userId) {
      setIsLoading(true);
      await startImpersonation(userId);
      setIsLoading(false);
    }
  };

  const handleSubmit = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    handleStartImpersonation();
  };

  return (
    <>
      <ImpersonationToolbar.Content>
        <form className={css.form} onSubmit={handleSubmit}>
          <Form.Control
            autoFocus
            className={css.input}
            onChange={handleInputChange}
            required
            placeholder="Impersonate user by ID"
            type="string"
            value={userId || ''}
          />
        </form>
      </ImpersonationToolbar.Content>

      <ImpersonationToolbar.Actions>
        <Button isLoading={isLoading} onClick={handleStartImpersonation}>
          Start Impersonation
        </Button>
      </ImpersonationToolbar.Actions>
    </>
  );
};
